export default {
  state: {
    shopCategories: [],
    loading: false,
  },
  getters: {
    shopCategories: state => state.shopCategories,
    loading: state => state.loading,
  },
  mutations: {
    setShopCategories(state, shopCategories) {
      state.shopCategories = shopCategories;
    },
    setLoading(state, display) {
      state.loading = display;
    }
  },
  actions: {
    async fetchAll({ commit }) {
      commit('setLoading', true);
      try {
        const shopCategories = await axios.get('api/shop-categories');
        commit('setShopCategories', shopCategories);
      } catch (e) {
      }
      commit('setLoading', false);
    },

    async fetch({ commit }, id) {
      try {
        return await axios.get('api/shop-categories/' + id);
      } catch (e) {
      }
    },

    async add({ commit }, payLoad) {
      try {
        await axios.post('api/shop-categories', payLoad);
      } catch (e) {
      }
    },

    async update({ commit }, payLoad) {
      try {
        await axios.put('api/shop-categories', payLoad);
      } catch (e) {
      }
    },

    async delete({}, id) {
      await axios.delete('api/shop-categories/' + id);
    }
  },
};
